import { render, staticRenderFns } from "./ViewerHelpTab.vue?vue&type=template&id=9a233650&"
import script from "./ViewerHelpTab.vue?vue&type=script&lang=js&"
export * from "./ViewerHelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports